<template>
    <div>
        <LoadingOverlay :loading="loading" />
        <div class="topThreeRewards-box">
            <div class="rewardsBoxes">
                <div class="rewardsBox">
                    <div class="rewardsBox-In" @click="redirectProfile(RichLastweekData[1].user?.id, RichLastweekData[1].user?.profile_id, RichLastweekData[1].user?.rich_level)">
                        <div class="rewardsProfile-imageBox">
                            <img :src='ProfileFrame2' class="profile-imgFrame" alt="pf-frame" />
                            <div class="profile-imageBox" v-if="RichLastweekData.length > 1">
                                <img class="overlapImg" :src='RichLastweekData[1].user.profile_images[0].image_name'
                                    alt="User Image" />
                            </div>
                            <div class="rewards-level" v-if="RichLastweekData.length > 1">
                                <img :src="getLevelImage(RichLastweekData[1].user?.rich_level || 0)" class="lavelImage"
                                    alt="level icon" />
                                <span class="lavel-value">{{ RichLastweekData[1].user?.rich_level || 0 }}</span>
                            </div>
                        </div>
                        <div class="userName-box">
                            <div class="userName" v-if="RichLastweekData.length > 1">{{ RichLastweekData[1].user?.name || "Unknown User" }}
                            </div>
                            <div class="beansBox">
                                <img :src='diamondIcon' class="diamondIcon" alt="" />
                                <span class="beansValue" v-if="RichLastweekData.length > 1">{{
                                RichLastweekData[1].total_coin_spend
                            }}</span>
                            </div>
                            <div class="userRewardsBox mt-0" v-if="RichLastweekData.length > 1">
                                <div v-if="RichLastweekData[1].reward_coin > 0">
                                    <span>Reward</span>{{ RichLastweekData[1].reward_coin }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rewardsBox center-rewardsBox">
                    <div class="rewardsBox-In" @click="redirectProfile(RichLastweekData[0].user?.id, RichLastweekData[0].user?.profile_id, RichLastweekData[0].user?.rich_level)">
                        <div class="rewardsProfile-imageBox">
                            <img :src='ProfileFrame1' class="profile-imgFrame" alt="pf-frame" />
                            <div class="profile-imageBox" v-if="RichLastweekData.length > 0">
                                <img class="overlapImg" :src='RichLastweekData[0].user.profile_images[0].image_name'
                                    alt="User Image" />
                            </div>
                            <div class="rewards-level" v-if="RichLastweekData.length > 0">
                                <img :src="getLevelImage(RichLastweekData[0].user?.rich_level || 0)" class="lavelImage"
                                    alt="level icon" />
                                <span class="lavel-value">{{ RichLastweekData[0].user?.rich_level || 0 }}</span>
                            </div>
                        </div>
                        <div class="userName-box">
                            <div class="userName" v-if="RichLastweekData.length > 0">{{ RichLastweekData[0].user?.name || "Unknown User" }}
                            </div>
                            <div class="beansBox">
                                <img :src='diamondIcon' class="diamondIcon" alt="" />
                                <span class="beansValue" v-if="RichLastweekData.length > 0">{{
                                RichLastweekData[0].total_coin_spend
                            }}</span>
                            </div>
                            <div class="userRewardsBox mt-0" v-if="RichLastweekData.length > 0">
                                <div v-if="RichLastweekData[0].reward_coin > 0">
                                    <span>Reward</span>{{ RichLastweekData[0].reward_coin }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rewardsBox">
                    <div class="rewardsBox-In" @click="redirectProfile(RichLastweekData[2].user?.id, RichLastweekData[2].user?.profile_id, RichLastweekData[2].user?.rich_level)">
                        <div class="rewardsProfile-imageBox">
                            <img :src='ProfileFrame3' class="profile-imgFrame" alt="pf-frame" />
                            <div class="profile-imageBox" v-if="RichLastweekData.length > 2">
                                <img class="overlapImg" :src='RichLastweekData[2].user.profile_images[0].image_name'
                                    alt="User Image" />
                            </div>
                            <div class="rewards-level" v-if="RichLastweekData.length > 2">
                                <img :src="getLevelImage(RichLastweekData[2].user?.rich_level || 0)" class="lavelImage"
                                    alt="level icon" />
                                <span class="lavel-value">{{
                                RichLastweekData[2].user?.rich_level || 0 }}</span>
                            </div>
                        </div>
                        <div class="userName-box">
                            <div class="userName" v-if="RichLastweekData.length > 2">{{ RichLastweekData[2].user?.name || "Unknown User" }}
                            </div>
                            <div class="beansBox">
                                <img :src='diamondIcon' class="diamondIcon" alt="" />
                                <span class="beansValue" v-if="RichLastweekData.length > 2">{{
                                RichLastweekData[2].total_coin_spend
                            }}</span>
                            </div>
                            <div class="userRewardsBox mt-0" v-if="RichLastweekData.length > 2">
                                <div v-if="RichLastweekData[2].reward_coin > 0">
                                    <span>Reward</span>{{ RichLastweekData[2].reward_coin }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="podiumImageBox">
                <img class="podiumImage" :src='podiumImage' alt="Podium Image" />
            </div>
        </div>
        <div class="fixHeight ringlive-datalistWrap">
            <div class="listBoxes" v-for="(reward, index) in RichLastweekData.slice(3) " :key="reward.id"
                @click="redirectProfile(reward.user?.id, reward.user?.profile_id, reward.user?.rich_level)">
                <div class="leftBxb">
                    <div class="s-no">{{ index + 4 }}</div>
                    <div class="listIconBox">
                        <div class="profPic">
                            <img :src='reward.user && reward.user.profile_images.length > 0 ? reward.user.profile_images[0].image_name : defaultUserImage'
                                alt="User Image" />
                        </div>
                    </div>
                    <div class="name-lavel-box">
                        <div class="userName">{{ reward.user?.name || "Unknown User" }}</div>
                        <div class="lavel-box">
                            <img :src="getLevelImage(reward.user?.rich_level || 0)" class="lavelImage" alt="level icon" />
                            <span class="lavel-value">{{ reward.user?.rich_level || 0 }}</span>
                        </div>
                    </div>
                </div>
                <div class="rightBox">
                    <div class="rightBox-in">
                        <div class="beansBox">
                            <img :src='diamondIcon' class="diamondIcon" alt="beans icons" />
                            {{ reward.total_coin_spend || 0 }}
                        </div>
                        <div class="userRewardsBox" v-if="reward.reward_coin > 0">
                            <span>Reward</span>{{ reward.reward_coin }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="personalDetails" class="listBoxes myselfBox" 
        @click="redirectProfile(personalDetails.id, personalDetails.profile_id, personalDetails.rich_level)">
            <div class="leftBxb">
                <div class="s-no">-</div>
                <div class="listIconBox">
                    <div class="profPic">
                        <img :src="personalDetails.profile_images.length > 0 ? personalDetails.profile_images[0].image_name : defaultUserImage"
                            alt="User Image" @error="setDefaultImage" />
                    </div>
                </div>
                <div class="name-lavel-box">
                    <div class="userName">{{ personalDetails.name }}</div>
                    <div class="lavel-box">
                        <img :src="getLevelImage(personalDetails.rich_level)" class="lavelImage" alt="level icon" />
                        <span class="lavel-value">{{ personalDetails.rich_level }}</span>
                    </div>
                </div>
            </div>
            <div class="rightBox">
                <div class="rightBox-in"><img :src='diamondIcon' class="diamondIcon" alt="diamond icons" />{{
                    personalDetails.weekly_spend_beans }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import ProfileFrame1 from '../../assets/images/rank1-frameImage.png'
import ProfileFrame2 from '../../assets/images/rank2-frameImage.png'
import ProfileFrame3 from '../../assets/images/rank3-frameImage.png'
import diamondIcon from '../../assets/images/diamond-icon.png'
import podiumImage from '../../assets/images/podium-background.webp'
import defaultUserImage from '../../assets/images/default_profile.webp';
import LoadingOverlay from '../LoadingOverlay.vue'
export default {
    name: 'RichLastWeekTabCont',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            RichLastweekData: [],
            personalDetails: null,
            ProfileFrame1: ProfileFrame1,
            ProfileFrame2: ProfileFrame2,
            ProfileFrame3: ProfileFrame3,
            diamondIcon: diamondIcon,
            podiumImage: podiumImage,
            defaultUserImage: defaultUserImage,
            loading: false,
        }
    },
    watch: {
        '$route.params.profile_id': 'fetchRichLastweekData'
    },
    mounted() {
        this.fetchRichLastweekData();
    },
    methods: {
        fetchRichLastweekData() {
            this.loading = true;
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            const apiUrl = `api/top-rich-weekly?type=last_week`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.RichLastweekData = response.data.result.data;
                    this.personalDetails = response.data.result.personal_details;
                    this.checkAllImagesExist();
                })

                .catch(error => {
                    console.error("Error Featching This Week Data", error)
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        getLevelImage(charm_level) {
            switch (true) {
                case charm_level === 0:
                    return require('@/assets/images/rich-lavel-0.png');
                case charm_level === 1:
                    return require('@/assets/images/rich-lavel-1.png');
                case charm_level === 2:
                    return require('@/assets/images/rich-lavel-2.png');
                case charm_level === 3:
                    return require('@/assets/images/rich-lavel-3.png');
                case charm_level === 4:
                    return require('@/assets/images/rich-lavel-4.png');
                case charm_level >= 5 && charm_level <= 8:
                    return require('@/assets/images/rich-lavel-5-8.png');
                case charm_level >= 9 && charm_level <= 11:
                    return require('@/assets/images/rich-lavel-9-11.png');
                case charm_level === 12:
                    return require('@/assets/images/rich-lavel-12.png');
                case charm_level === 13:
                    return require('@/assets/images/rich-lavel-13.png');
                case charm_level === 14:
                    return require('@/assets/images/rich-lavel-14.png');
                case charm_level === 15:
                    return require('@/assets/images/rich-lavel-15.png');
                default:
                    return require('@/assets/images/rich-lavel-0.png');
            }
        },
        checkAllImagesExist() {
            this.RichLastweekData.forEach(reward => {
                if (
                    reward.user &&
                    reward.user.profile_images &&
                    reward.user.profile_images !== "null" &&
                    reward.user.profile_images !== undefined &&
                    reward.user.profile_images.length > 0
                ) {
                    const imageUrl = reward.user.profile_images[0].image_name;
                    this.checkImageExists(imageUrl)
                        .then(exists => {
                            if (!exists) {
                                reward.user.profile_images[0].image_name = this.defaultUserImage;
                            }
                        });
                } else {
                    reward.user.profile_images = [{ image_name: this.defaultUserImage }];
                }
            });
        },
        checkImageExists(imageUrl) {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = function () {
                    resolve(true);
                };
                img.onerror = function () {
                    resolve(false);
                };
                img.src = imageUrl;
            });
        },

        setDefaultImage(event) {
            event.target.src = this.defaultUserImage;
        },

        redirectProfile(id, profile_id, level) {
            if (window.navigator.userAgent.indexOf("Android") > -1) {
                const baseURL = 'female-weekly-rewards';
                const params = {
                    id: id,
                    profile_id: profile_id,
                    level: level
                };
                const queryString = Object.keys(params)
                    .map(key => `${key}=${params[key]}`)
                    .join('&');
                const url = `${baseURL}?${queryString}`;
                //console.warn(url)
                Android.redirectProfile(url);
            }
        }
    },
}
</script>